import * as Joi from 'joi';
import { ChartVizPropVersion, } from '../../types/prism';
import { commonV1DeprecatedProps } from './v1';
import { AxisPropertiesSchema } from './v2';
import { ChartPropertiesSchemaV4, ChartSpecificObjectSchema, ColumnPropertiesSchemaV4, MultiColorSchema, SeriesColorSchema, } from './v4';
export const DEFAULT_CHART_SPECIFICV4dot1 = {
    __typename: 'ChartSpecificProperties',
    hidePivotSummaries: null,
    isHeatmapOverlayed: null,
    isStackedAsPercent: null,
    markersEnabled: null,
    pivotState: null,
    stackedAsPercentFormat: null,
    summaryFormat: null,
    summaryMode: null,
    useFlatLayout: null,
    customProps: null,
};
export const TooltipConfigSchema = Joi.object({
    columnIds: Joi.array().items(Joi.string()),
    __typename: Joi.string().valid('TooltipConfig'),
});
export const ChartSpecificObjectSchemaV4dot1 = {
    ...ChartSpecificObjectSchema,
    customProps: Joi.string().allow(null),
};
export const ChartPropertiesSchemaV4dot1 = {
    ...ChartPropertiesSchemaV4,
    chartSpecific: Joi.object(ChartSpecificObjectSchemaV4dot1)
        .pattern(/\d/, Joi.any())
        .allow(null),
};
class ClientStateV4dot1Class {
}
export const ClientStateV4dot1Props = {
    __typename: Joi.string().valid('ChartVizProps'),
    axisProperties: Joi.array().items(Joi.object({
        __typename: Joi.string().valid('AxisObj'),
        id: Joi.string(),
        properties: AxisPropertiesSchema,
    })),
    columnProperties: Joi.array().items(Joi.object({
        __typename: Joi.string().valid('ChartColumnPropertyMap'),
        columnId: Joi.string(),
        columnProperty: ColumnPropertiesSchemaV4,
    })),
    chartProperties: Joi.object(ChartPropertiesSchemaV4dot1),
    seriesColors: Joi.array().items(SeriesColorSchema),
    systemSeriesColors: Joi.array().items(SeriesColorSchema),
    systemMultiColorSeriesColors: Joi.array().items(MultiColorSchema),
    multiColorSeriesColors: Joi.array().items(MultiColorSchema),
    customColorSelectorArray: Joi.array()
        .items(Joi.string())
        .allow(null),
    tooltipConfig: TooltipConfigSchema.allow(null),
};
const ClientStateV4dot1Schema = Joi.object({
    ...ClientStateV4dot1Props,
    version: Joi.string().valid(ChartVizPropVersion.V4Dot1),
});
const DeprecatedClientStateV4Dot1Schema = ClientStateV4dot1Schema.concat(Joi.object({
    ...commonV1DeprecatedProps,
    custom_color_selector_array: Joi.array(),
})).fork('chartProperties', (schema) => schema.keys({
    showRoundedNumbers: Joi.boolean(),
}));
export { ClientStateV4dot1Class, ClientStateV4dot1Schema, DeprecatedClientStateV4Dot1Schema, };
//# sourceMappingURL=v4dot1.js.map